import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=7b859ec0&scoped=true&"
import script from "./ProfileIcon.vue?vue&type=script&lang=ts&"
export * from "./ProfileIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileIcon.vue?vue&type=style&index=0&id=7b859ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b859ec0",
  null
  
)

export default component.exports